import './styles/user-list-item.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import { Modal, Button, Header, Icon } from 'semantic-ui-react'

import { getUserFriendlyRoleName } from './utils'

import api from '../redux/api'

import {
  setSelectedCategory,
} from '../redux/actions/items'


class UserListItem extends React.Component {
  state = {
    confirm: false,
  }

  static propTypes = {
    item:                PropTypes.object.isRequired,
    history:             PropTypes.object.isRequired,
    setSelectedCategory: PropTypes.func.isRequired,
  }

  handleDelete = (event) => {
    event.preventDefault()
    event.stopPropagation()
    
    const email = this.props.item.email

    if (window.confirm(`Are you sure you want to delete user ${email}?`)) {
      api.deleteUser({ id: email }).then(() => {
        this.props.setSelectedCategory('users')
      }).catch((error) => {
        alert(`Error deleting user: ${error.message}`)
      })
    }
  }

  renderConfirmation = () => {
    return (
      <div className="user-delete-confirmation">
        <Modal centered={false} open={this.state.confirm}>
          <Header icon='shipping fast' content='Retry Job' />
          <Modal.Content>
            <h5>Hello There</h5>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleClose}>Cancel</Button>
            <Button onClick={this.handleConfirm} primary>OK</Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }

  render() {
    const { item } = this.props

    return (
      <div className="user-list-item">
        <div className="user-email">{ item.email }</div>

        <div className="ui mini message">
          { getUserFriendlyRoleName(item.role) }
        </div>
        <div className="actions">
          <Icon name='trash alternate outline' onClick={this.handleDelete} />
        </div>

        { this.renderConfirmation() }
      </div>
    )
  }
}

const mapDispatchToProps = { setSelectedCategory }
const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(UserListItem)